import { ID_SPLITTER } from "../dataTypes";

const splitId = (id: string | undefined) => (id ? id.split(ID_SPLITTER) : []);

export default splitId;
